<div
  *vsLet="isMobile$ | async as isMobile"
  class="flex gap-4 h-full max-w-full transition-all"
  [class.ml-4]="!isMobile && collapsible"
>
  <div *ngIf="!isMobile && collapsible" class="flex flex-col items-center h-full">
    <vs-icon
      class="rounded-full bg-base border p-1 cursor-pointer"
      [name]="open ? 'chevron-right-double' : 'chevron-left-double'"
      (click)="open = !open"
    ></vs-icon>

    <div class="h-full border-l"></div>
  </div>
  <div *vsLet="activities$ | async as activities" class="flex flex-col flex-grow gap-4 w-[50%]">
    <div class="flex gap-4 justify-between">
      <p *ngIf="activities?.[0] as latest" class="text-xs font-normal text-gray-400 self-center">
        Last updated: {{ latest.created | date: 'dd/MM/yy hh:mm' }}
        <span class="text-primary-500 cursor-pointer" (click)="refresh()">Refresh</span>
      </p>

      <vs-select
        vsInput
        class="self-center"
        [config]="{ placeholder: 'All links' }"
        (valueChanges)="setLinkType($event)"
      >
        <li vs-select-option [value]="null">All links</li>
        <li *ngFor="let type of linkTypes" vs-select-option [value]="type">
          {{ type ? (type.replace('C', ' C').replace('I', ' I') | titlecase) : 'Unknown' }}
        </li>
      </vs-select>
    </div>

    <div *ngIf="!loading; else isLoading" class="flex flex-col">
      <ng-container *ngIf="activities && activities.length > 0; else noActivities">
        <ng-container *ngFor="let activity of activities; index as index">
          <ws-claim-timeline-activity
            *ngIf="activity"
            class="w-full"
            [claim]="claim"
            [activity]="activity"
            [displayType]="linkType"
            [isCustomerPortal]="isCustomerPortal"
            [hideLine]="index === (activities?.length || 0) - 1"
          ></ws-claim-timeline-activity>
        </ng-container>
      </ng-container>
    </div>

    <ng-template #noActivities>
      <div class="flex flex-col items-center justify-center min-h-[275px] text-center">
        <vs-icon name="file-search-02" class="text-gray-400 mb-3" size="35"></vs-icon>
        <p class="text-sm font-semibold text-gray-700">No activity history found</p>
        <p class="text-xs text-gray-500">Activity for this claim will appear here</p>
      </div>
    </ng-template>

    <ng-template #isLoading>
      <div class="flex items-center justify-center min-h-[275px]">
        <vs-icon name="loading-01" class="text-primary-500 animate-spin" size="35"></vs-icon>
      </div>
    </ng-template>
  </div>
</div>
